import { render, staticRenderFns } from "./SummaryBoard.vue?vue&type=template&id=3f8927b6&scoped=true&"
import script from "./SummaryBoard.vue?vue&type=script&lang=js&"
export * from "./SummaryBoard.vue?vue&type=script&lang=js&"
import style0 from "./SummaryBoard.vue?vue&type=style&index=0&id=3f8927b6&lang=scss&scoped=true&"
import style1 from "./SummaryBoard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8927b6",
  null
  
)

export default component.exports